import Vue from 'vue'
import App from './App.vue'
import router from './router' // 路由
import store from './store' // 引入 Vuex store
import ElementUI from 'element-ui' //  Elm ui
// import 'element-ui/lib/theme-chalk/index.css'
import './components/theme/index.css'
import md5 from 'js-md5'
import VueLoadmore from 'vuejs-loadmore'
import axios from '@/api/request.js'
Vue.prototype.$http = axios.axios

// 请求拦截器
// axios_.interceptors.request.use(
//   config => {
//     console.log('---请求拦截器请求拦截器请求拦截器请求拦截器-->')
//   },
//   error => {
//     return Promise.reject(error)
//   }
// )

Vue.config.productionTip = false

Vue.prototype.$md5 = md5

import Loading from '@/components/Loading'
Vue.component('Loading', Loading)
import HomeCar from '../src/components/HomeCar'
Vue.component('HomeCar', HomeCar)
import HomeButtom from '../src/components/HomeButtom'
Vue.component('HomeButtom', HomeButtom)
import BidDing from '../src/components/BidDing'
Vue.component('BidDing', BidDing)
import AuCtion from '../src/components/AuCtion'
Vue.component('AuCtion', AuCtion)
import ProJects from '../src/components/ProJects'
Vue.component('ProJects', ProJects)

// 操作手册
import caozuoshouce from '../src/components/caozuoshouce'
Vue.component('caozuoshouce', caozuoshouce)

// 企业资料/保证金

import qyzl_bzj from '../src/components/qyzl_bzj'
Vue.component('qyzl_bzj', qyzl_bzj)

import personalCenter from '../src/components/personalCenter'
Vue.component('personalCenter', personalCenter)

import resetPasswords from '../src/components/resetPasswords'
Vue.component('resetPasswords', resetPasswords)

import upload from '../src/components/upload/upload'
Vue.component('my-upload', upload)

// 解决el-radio报错问题
Vue.directive('removeAriaHidden', {
  bind(el) {
    const ariaEls = el.querySelectorAll('.el-radio__original')
    ariaEls.forEach(item => {
      item.removeAttribute('aria-hidden')
    })
  }
})

Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

Vue.use(ElementUI)

Vue.use(VueLoadmore)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

//路由守卫
